import "./OptionChooser.css";

interface TextInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  isDisabled?: boolean;
  placeholder?: string;
}

const TextInput: React.FC<TextInputProps> = ({
  label,
  value,
  onChange,
  isDisabled = false,
  placeholder,
}) => {
  return (
    <div className={`store-front-input-group${isDisabled ? ' store-front-input-group--disabled' : ''}`}>
      <label className="store-front-label">{label}</label>
      <input
        type="text"
        className="store-front-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={isDisabled}
      />
    </div>
  );
};

export default TextInput;
